import { Injectable } from '@angular/core';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import { environment } from '../../environments/environment';
import { ErrorHandlerService } from './error-handler.service';
import { HttpParams, HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { EncrDecrService } from './encr-decr.service';

@Injectable()
export class CommonService {

    constructor(
        private http: HttpClient,
        private errorHandlerService: ErrorHandlerService,
        private EncrDecr: EncrDecrService
    ) { }

    login(email: string, password: string) {
        const headers = new HttpHeaders();
        headers.append('Content-Type', 'application/x-www-form-urlencoded');
        let params = new HttpParams();
        params = params.append('userName', email);
        params = params.append('password', password);
        params = params.append('grant_type', 'password');
        return this.http.post(environment.apiUrl + 'Token', params, { headers })
            .map((response: any) => {
                // login successful if there's a jwt token in the response
                const user = response;
                if (user && user.access_token) {
                    // store user details and jwt token in local storage to keep user logged in between page refreshes
                    localStorage.setItem('wid', user.Id);
                    localStorage.setItem('worqforctoken', user.access_token);
                    localStorage.setItem('username', user.userName);
                    localStorage.setItem('email', user.email);
                    localStorage.setItem('Page', user.Page);
                    localStorage.setItem('Permissions', this.EncrDecr.set(user.Permissions));
                    localStorage.setItem('lastlogin', user.lastlogin);
                }
                return user.url;
            })
            .catch(this.errorHandlerService.AuthhandleError);
    }


    Post(ControllerName: any, ActionName: any, Data: any) {
        return this.http.post(environment.apiUrl + 'api/' + ControllerName + '/' + ActionName, Data)
            .map((response: any) => {
                return response;
            }).catch(this.errorHandlerService.handleError);
    }

    Get(ControllerName: any, ActionName: any) {
        const url = environment.apiUrl + 'api/' + ControllerName + '/' + ActionName;
        return this.http.get(url)
            .map((response: any) => {
                return response;
            }).catch(this.errorHandlerService.handleError);
    }

    PostWithAuth(ControllerName: any, ActionName: any, Data: any) {
        const headers = this.SetHeaderOption();
        return this.http.post(environment.apiUrl + 'api/' + ControllerName + '/' + ActionName, Data, { headers })
            .map((response: any) => {
                return response;
            }).catch(this.errorHandlerService.handleError);
    }

    GetWithAuth(ControllerName: any, ActionName: any) {
        const headers = this.SetHeaderOption();
        const url = environment.apiUrl + 'api/' + ControllerName + '/' + ActionName;
        return this.http.get(url, { headers })
            .map((response: any) => {
                return response;
            }).catch(this.errorHandlerService.handleError);
    }

    async GetAsyncWithAuth(ControllerName: any, ActionName: any) {
        const headers = this.SetHeaderOption();
        const url = environment.apiUrl + 'api/' + ControllerName + '/' + ActionName;
        return await this.http.get(url, { headers })
            .map((response: any) => {
                return response;
            }).catch(this.errorHandlerService.handleError);
    }

    SetHeaderOption() {
        const usertoken = localStorage.getItem('worqforctoken');
        const token: string = 'Bearer ' + usertoken;
        let headers = new HttpHeaders();
        headers = headers.set('Authorization', token);
        return headers;
    }

    GetLookupList() {
        return new Array(
            'Contract Type',
            'Country Code',
            'DeclineType',
            'Document Group',
            'Document Type',
            'General Section',
            'Health Status',
            'Logbook Status',
            'Membership',
            'Method Standard',
            'NDT Method',
            'NDT Method Technique',
            'Organisation Type',
            'Qualification Body',
            'Qualification Level',
            'Qualification Sector',
            'Sector Experience',
            'Skill Level',
            'Specific Technical Code',
            'Specific Testing Experience',
            'Training School',
            'ValidateType',
        );
    }

    GetTechnicianLookup() {
        return new Array(
            'Document Type',
            'General Section',
            'Method Standard',
            'NDT Method',
            'NDT Method Technique',
            'Organisation Type',
            'Qualification Body',
            'Sector Experience',
            'Specific Technical Code',
            'Specific Testing Experience',
            'Training School'
        );
    }

    downloadFile(FileContent) {
        const byteCharacters = atob(FileContent.Content);
        const byteArrays = [];

        for (let offset = 0; offset < byteCharacters.length; offset += FileContent.Content.length) {
            const slice = byteCharacters.slice(offset, offset + FileContent.Content.length);
            const byteNumbers = new Array(slice.length);

            for (let i = 0; i < slice.length; i++) {
                byteNumbers[i] = slice.charCodeAt(i);
            }

            const byteArray = new Uint8Array(byteNumbers);
            byteArrays.push(byteArray);
        } // const byteCharacters = atob(FileContent.Content);


        const blob = new Blob(byteArrays, {
            type: FileContent.MimeType
        });
        const fileName = FileContent.FileName;
        const objectUrl = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = objectUrl;
        a.download = fileName;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        URL.revokeObjectURL(objectUrl);
    }
}
